export type OdReviewRunStatus = "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED";

export type OdReviewIssueStatus =
  | "PENDING"
  | "ACCEPTED"
  | "REJECTED"
  | "PENDING_MANUAL"
  | "RESOLVED_MANUAL";

export type OdReviewErrorType =
  | "RECURSO_INCORRECTO"
  | "RECURSO_FALTANTE"
  | "REFERENCIA_NO_VERIFICABLE"
  | "FOTO_INCORRECTA"
  | "CONTENIDO_INCORRECTO"
  | "ERROR_DE_TEXTO";

export type OdReviewTargetField =
  | "title"
  | "description"
  | "materials"
  | "instructions"
  | "photo"
  | "resource"
  | "resource_reference";

export type OdReviewOperation = "replace" | "remove" | "add" | "manual";

export const OD_REVIEW_PHASES = ["text", "resources", "photos"] as const;

export type OdReviewPhase = (typeof OD_REVIEW_PHASES)[number];

export interface OdReviewRunSummary {
  id: number;
  status: OdReviewRunStatus;
  course_ids: number[];
  phases: OdReviewPhase[];
  total_activities: number;
  reviewed_activities: number;
  issues_found: number;
  pages_read: number;
  pages_rendered: number;
  photos_reviewed: number;
  unverifiable_references: number;
  estimated_cost_usd: number | null;
  soft_deadline_reached_at: string | null;
  error_message: string | null;
  created_at: string;
  updated_at: string | null;
}

export type OdReviewRunDetail = OdReviewRunSummary;

export interface OdReviewIssue {
  id: number;
  run_id: number;
  course_id: number;
  lesson_id: number;
  activity_id: number;
  block_id: number | null;
  order_key: number;
  error_type: OdReviewErrorType;
  error_title: string;
  error_description: string;
  evidence: string;
  recommended_fix: string;
  target_field: OdReviewTargetField;
  operation: OdReviewOperation;
  original_value: string | null;
  suggested_value: string | null;
  applied_value: string | null;
  replacement_photo_brief: string | null;
  photo_file_id: string | null;
  resource_id: number | null;
  resource_file_id: number | null;
  resolved_page_number: number | null;
  resource_reference: string | null;
  status: OdReviewIssueStatus;
  degraded_reason: string | null;
  source_updated_at: string | null;
  dedup_hash: string;
  reviewed_by_id: number | null;
  reviewed_at: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface OdReviewCourseProgramOption {
  program_id: number;
  program_title: string;
  program_code: string | null;
  week: string;
}

export interface OdReviewCourseOption {
  course_id: number;
  course_title: string;
  programs: OdReviewCourseProgramOption[];
}
